import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import {
  Image,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Link as ChakraLink,
  Box,
  Text,
  Divider,
} from "@chakra-ui/react";
import "./DynoName.scss";

export const DynoName = ({
  title,
  userRole,
  dyno,
  classId,
  removeDyno,
  viewSubmissions,
}) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      pt="20px"
      pb="20px"
    >
      <Flex alignItems="center" maxWidth="40%" width="100%">
        <Image
          position="relative"
          src="/images/icon-practice.svg"
          alt="Practice dyno"
        />
        <ChakraLink
          as={ReactRouterLink}
          variant="ghost"
          width="100%"
          fontSize="16px"
          ml={2}
          _hover={{ color: "rgb(27, 110, 194)" }}
          fontWeight={600}
          color="rgb(66, 71, 112)"
          to={`/viewer/${dyno.id}/${classId}`}
        >
          {title}
        </ChakraLink>
      </Flex>
      {userRole === "Student" ? (
        dyno.dynosStats !== 0 ? (
          <Flex
            maxWidth="40%"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box color="rgb(66, 71, 112)">
              <Text fontSize="14px" fontWeight={600}>
                {dyno.dynosStats}
              </Text>
              <Text fontSize="11px" textTransform="uppercase" fontWeight={500}>
                last accessed
              </Text>
            </Box>
            <Text
              textTransform="capitalize"
              fontWeight={600}
              color="rgb(27, 110, 194)"
              fontSize="16px"
            >
              keep practicing
            </Text>
          </Flex>
        ) : (
          <Flex
            maxWidth="40%"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box color="rgb(66, 71, 112)">
              <Text fontSize="14px" fontWeight={600}>
                -
              </Text>
            </Box>
            <Text
              textTransform="capitalize"
              fontWeight={600}
              color="rgb(27, 110, 194)"
              fontSize="16px"
            >
              Start Practice
            </Text>
          </Flex>
        )
      ) : (
        <Box
          color="rgb(30, 135, 77)"
          fontWeight={600}
          maxWidth="40%"
          width="100%"
        >
          <Text fontSize="18px" fontWeight={600}>
            {dyno.dynosStats}
          </Text>
          <Text fontSize="11px" textTransform="uppercase" fontWeight={500}>
            <span>students</span> practiced
          </Text>
        </Box>
      )}
      <Menu>
        <MenuButton>
          <Image
            position="relative"
            src="/images/icon-menu.svg"
            alt="Practice dyno"
            width="16px"
            height="16px"
            opacity="0.8"
            className="rotate"
          />
        </MenuButton>
        <MenuList borderColor="rgba(0, 176, 255, 0.3)">
          {userRole !== "Student" && (
            <MenuItem
              onClick={removeDyno}
              _hover={{ backgroundColor: "rgba(0, 176, 255, 0.16)" }}
              _focus={{ backgroundColor: "rgba(0, 176, 255, 0.16)" }}
            >
              <Image
                position="relative"
                src="/images/icon-delete.svg"
                alt="delete dyno"
                width="26px"
                height="23px"
                marginRight="5px"
              />
              Remove
            </MenuItem>
          )}
          <Divider />
          <MenuItem
            onClick={viewSubmissions}
            _hover={{ backgroundColor: "rgba(0, 176, 255, 0.16)" }}
            _focus={{ backgroundColor: "rgba(0, 176, 255, 0.16)" }}
          >
            <Image
              position="relative"
              src="/images/icon-view.svg"
              alt="View submission"
              width="26px"
              height="23px"
              marginRight="5px"
            />
            {userRole !== "Student"
              ? "View submissions"
              : "View my submissions"}
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
};
